<template>
    <el-dialog
        :title="'逾期登记页面'"
        :width="'700px'"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'performanceOverdueRegisterDialog'"
    >
        <el-form
            ref="overdueRegisterForm"
            :model="overdueRegisterForm"
            :rules="overdueRegisterFormRules"
            label-width="110px"
        >
            <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item prop="overdueType">
                        <el-select
                            v-model="overdueRegisterForm.overdueType"
                            clearable
                            style="width: 100%"
                            placeholder="逾期类型"
                            @change="handleOverdueTypeChange"
                        >
                            <el-option
                                v-for="item in overdueTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="overdueReason">
                        <el-select
                            v-model="overdueRegisterForm.overdueReason"
                            clearable
                            style="width: 100%"
                            placeholder="一级逾期原因"
                            @change="handleFirstOverdueChange"
                        >
                            <el-option
                                v-for="item in firstOverdueList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="overdueReasDetail">
                        <el-select
                            v-model="overdueRegisterForm.overdueReasDetail"
                            clearable
                            style="width: 100%"
                            placeholder="二级逾期原因"
                        >
                            <el-option
                                v-for="item in secondOverdueList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item prop="overdueDesc">
                        <el-input
                            type="textarea"
                            clearable
                            placeholder="逾期原因描述"
                            resize="none"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="overdueRegisterForm.overdueDesc"
                            maxlength="250"
                            show-word-limit
                        />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div>
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    @click="handleSubmit"
                    >确定</el-button
                >
            </div>
        </template>
    </el-dialog>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api.js';
import { formatDictDataToLabelValue, filterDictDataByVal, CURRENT_OVERDUE_TYPE } from '../util.js';
import { receiptOverdue } from '@/modules/transport/otp/api/performanceReceiptSign.js';
export default {
    name: 'performanceOverdueRegisterDialog',
    props: {
        selected: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            btnLoading: false,
            overdueTypeList: [], // 逾期类型列表
            firstOverdueList: [], // 一级逾期原因列表
            secondOverdueList: [], // 二级逾期原因列表
            overdueRegisterForm: {
                overdueType: '', // 逾期类型
                overdueReason: '', // 一级逾期原因
                overdueReasDetail: '', // 二级逾期原因
                overdueDesc: '' // 逾期描述
            },
            overdueRegisterFormRules: {
                overdueType: [{ required: true, message: '请选择逾期类型', trigger: ['change'] }],
                overdueReason: [{ required: true, message: '请选择一级逾期原因', trigger: ['change'] }],
                overdueReasDetail: [{ required: true, message: '请选择二级逾期原因', trigger: ['change'] }]
            },
            dictData: {}, // 字典数据
            currentSecondOverdueType: {} // 当前二级逾期类型字典数据
        };
    },
    async mounted () {
        await this.getDictData();
        this.overdueTypeList = formatDictDataToLabelValue(this.dictData.OTP_OVER_DUE_TYPE);
        this.setOverdueType('1');
    },
    methods: {
        /**
         * @description 数据字典列表
         * OTP_OVER_DUE_TYPE: 逾期类型
         * OVERDUE_ARRIVE_1: 一级逾期原因 注：一级逾期原因都使用同一个数据字典，只是二级逾期原因不同
         * OVERDUE_ARRIVE_2: 到货逾期二级原因
         * OVERDUE_RECEIPT_2: 签收逾期二级原因
         * PUPPLIER_TURN_OVER: 供方移交二级逾期原因
         * ACCOUNT_TURN_OVER: 结算移交二级逾期原因
         * ACCOUNT_TURN_OVER_SURE: 结算移交确认二级逾期原因
         */
        getDictData () {
            return dictWithUrl('OTP_OVER_DUE_TYPE,OVERDUE_ARRIVE_1,OVERDUE_ARRIVE_2,OVERDUE_RECEIPT_2,PUPPLIER_TURN_OVER,ACCOUNT_TURN_OVER,ACCOUNT_TURN_OVER_SURE').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data;
                }
            });
        },

        /**
         * @description 设置默认逾期类型
         * @param {String} val 默认选中的逾期类型值
         */
        setOverdueType (val) {
            this.overdueRegisterForm.overdueType = val;
            this.handleOverdueTypeChange(val);
        },

        /**
         * @description 选中逾期类型后回调
         * @param {String} val 当前选中的逾期类型值
         */
        handleOverdueTypeChange (val) {
            if (val === '') {
                this.$set(this.overdueRegisterForm, 'overdueReason', ''); // 清空一级逾期原因所选值
                this.$set(this.overdueRegisterForm, 'overdueReasDetail', ''); // 清空二级逾期原因所选值
                this.firstOverdueList = []; // 清空一级逾期原因下拉列表数据
                this.secondOverdueList = []; // 清空二级逾期原因下拉列表数据
            } else {
                this.$set(this.overdueRegisterForm, 'overdueReason', ''); // 清空一级逾期原因所选值
                this.$set(this.overdueRegisterForm, 'overdueReasDetail', ''); // 清空二级逾期原因所选值
                this.secondOverdueList = []; // 清空二级逾期原因下拉列表数据
                this.firstOverdueList = formatDictDataToLabelValue(this.dictData.OVERDUE_ARRIVE_1);
                this.currentSecondOverdueType = this.dictData[CURRENT_OVERDUE_TYPE[val]]; // 当前选中逾期类型所使用的二级逾期原因数据字典，需要结合filterDictDataByVal函数才能将数据映射成[{label: 'xx', value: 'xx'}]形式
            }
        },

        /**
         * @description 选中一级逾期原因回调
         * @param {String} val 当前选中的一级逾期原因值
         */
        handleFirstOverdueChange (val) {
            if (val === '') {
                this.$set(this.overdueRegisterForm, 'overdueReasDetail', '');
                this.secondOverdueList = [];
            } else {
                this.$set(this.overdueRegisterForm, 'overdueReasDetail', ''); // 清空二级逾期原因所选值
                this.secondOverdueList = filterDictDataByVal(val, this.currentSecondOverdueType); // 二级逾期原因列表
            }
        },

        /**
         * @description 确认
         */
        handleSubmit () {
            Promise.resolve(this.$refs.overdueRegisterForm.validate()).then(res => {
                this.btnLoading = true;
                const reqParams = this.getParams();
                receiptOverdue(reqParams).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('操作成功');
                        this.$emit('success', 'overdueRegisterVisible');
                    }
                }).finally(() => {
                    this.btnLoading = false;
                });
            }).catch(() => { });
        },
        // 组装查询参数
        getParams () {
            let taskNos; // 运输单号集合
            // 判断是单个逾期登记还是批量逾期
            if (Array.isArray(this.selected) && this.selected.length > 0) {
                taskNos = this.selected.map(item => item.taskNo);
            } else {
                taskNos = this.selected.taskNo;
            }
            const params = {
                taskNos: [...taskNos],
                ...this.overdueRegisterForm
            };
            return params;
        },
        beforeClose () {
            this.$emit('update:overdueRegisterVisible', false);
        }
    }
};
</script>

<style lang="less">
.performanceOverdueRegisterDialog {
    .el-dialog__body {
        padding: 25px 35px 0px 35px;
        .el-form-item {
            .el-form-item__content {
                margin-left: 0 !important;
            }
        }
    }
}
</style>
